import styled from 'styled-components';
import { IonPage } from '@ionic/react';

export const IonPageWrapper = styled(IonPage)`
  .refresh-button {
    position: absolute;
    z-index: 1000;
    right: 0;
    --background: none;
  }
`;